import api, { downloadFile } from '@/api';
import BaseModel from '@/models/base';

export default class File extends BaseModel {
  static entity = 'files';
  static apiPath = 'files';

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      size: this.string(''),
      is_public: this.attr(true),
    };
  }

  async download() {
    const { data } = await api.get(this.apiPath, { responseType: 'blob' });
    downloadFile(data, this.name);
  }
}
